var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0771 0.000610352H19.986C8.96909 0.000610352 0.0380859 8.93424 0.0380859 19.9544V20.0455C0.0380859 31.0657 8.96909 39.9993 19.986 39.9993H20.0771C31.094 39.9993 40.025 31.0657 40.025 20.0455V19.9544C40.025 8.93424 31.094 0.000610352 20.0771 0.000610352Z",
    fill: "url(#paint0_linear_115_1090)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2187 8.13818H13.8456C10.4273 8.13818 7.64648 10.9199 7.64648 14.3392V25.6621C7.64648 29.0814 10.4273 31.863 13.8456 31.863H26.2187C29.637 31.863 32.4179 29.0814 32.4179 25.6621V14.3392C32.4179 10.9199 29.637 8.13818 26.2187 8.13818ZM9.83335 14.3392C9.83335 12.1264 11.6336 10.3257 13.8456 10.3257H26.2187C28.4308 10.3257 30.231 12.1264 30.231 14.3392V25.6621C30.231 27.8748 28.4308 29.6755 26.2187 29.6755H13.8456C11.6336 29.6755 9.83335 27.8748 9.83335 25.6621V14.3392Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0329 25.7671C23.2116 25.7671 25.7991 23.1802 25.7991 19.9992C25.7991 16.8181 23.213 14.2312 20.0329 14.2312C16.8527 14.2312 14.2666 16.8181 14.2666 19.9992C14.2666 23.1802 16.8527 25.7671 20.0329 25.7671ZM20.0329 16.4201C22.0068 16.4201 23.6123 18.0261 23.6123 20.0006C23.6123 21.9751 22.0068 23.581 20.0329 23.581C18.0589 23.581 16.4535 21.9751 16.4535 20.0006C16.4535 18.0261 18.0589 16.4201 20.0329 16.4201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.332 15.1631C27.1879 15.1631 27.8856 14.4667 27.8856 13.609C27.8856 12.7514 27.1893 12.0549 26.332 12.0549C25.4746 12.0549 24.7783 12.7514 24.7783 13.609C24.7783 14.4667 25.4746 15.1631 26.332 15.1631Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_1090",
    x1: 40.025,
    y1: 39.9993,
    x2: -8.21133,
    y2: 18.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group-1.410c0e6274b309674a264d0be485a35b.svg";
export { ForwardRef as ReactComponent };